var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPassword = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.1665 10.8998C3.70627 10.8998 3.33317 11.2729 3.33317 11.7332V17.5665C3.33317 18.0267 3.70627 18.3998 4.1665 18.3998H15.8332C16.2934 18.3998 16.6665 18.0267 16.6665 17.5665V11.7332C16.6665 11.2729 16.2934 10.8998 15.8332 10.8998H4.1665ZM1.6665 11.7332C1.6665 10.3524 2.78579 9.23315 4.1665 9.23315H15.8332C17.2139 9.23315 18.3332 10.3524 18.3332 11.7332V17.5665C18.3332 18.9472 17.2139 20.0665 15.8332 20.0665H4.1665C2.78579 20.0665 1.6665 18.9472 1.6665 17.5665V11.7332Z",
    fill: "#60666E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 3.39982C9.11594 3.39982 8.2681 3.75101 7.64298 4.37613C7.01786 5.00125 6.66667 5.8491 6.66667 6.73315V10.0665C6.66667 10.5267 6.29357 10.8998 5.83333 10.8998C5.3731 10.8998 5 10.5267 5 10.0665V6.73315C5 5.40707 5.52678 4.1353 6.46447 3.19762C7.40215 2.25994 8.67392 1.73315 10 1.73315C11.3261 1.73315 12.5979 2.25994 13.5355 3.19762C14.4732 4.1353 15 5.40707 15 6.73315V10.0665C15 10.5267 14.6269 10.8998 14.1667 10.8998C13.7064 10.8998 13.3333 10.5267 13.3333 10.0665V6.73315C13.3333 5.8491 12.9821 5.00125 12.357 4.37613C11.7319 3.75101 10.8841 3.39982 10 3.39982Z",
    fill: "#60666E"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPassword);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/password.8931dcc1a5d0bb230ba4e04d96ca6747.svg";